<script setup>
import { computed, useSlots } from 'vue';

import {
	DsTag,
	DsText,
	DsGrid,
} from '@coloplast/design-system';

const props = defineProps({
	headline: String,
	tagText: String,
	colored: Boolean,
});

const classes = computed(() => {
	return {
		'c-stat-cards-container-block--card-colors': props.colored
	}
});

const slots = useSlots();

const columnsNo = computed(() => slots.default?.().length);
</script>

<template>
	<DsTag
		v-if="tagText"
		dot
		:text="tagText"
		class="c-stat-cards-container-block__tag">
	</DsTag>

	<DsGrid columns-xl="2">
		<DsText
			html-element="h2"
			text-type="heading-3xl"
			text-style="medium"
			class="c-stat-cards-container-block__headline">
			{{ headline }}
		</DsText>
	</DsGrid>

	<DsGrid
		:columns-md="columnsNo"
		:class="classes"
		data-testid="stat-cards-container-block-grid">
		<slot></slot>
	</DsGrid>
</template>

<style lang="scss">
@import 'shared/styles/settings/settings';
@import 'shared/styles/tools/tools';

.c-stat-cards-container-block {
	&__tag {
		margin-bottom: ds-space("6");
	}

	&__headline {
		margin-bottom: ds-space("10");
	}

	&--card-colors {
		div:nth-of-type(1) .c-stat-card-block {
			background-color: ds-color("bg", "brand-muted");

			.c-stat-card-block__text-text {
				color: ds-color("fg", "muted");
			}
		}

		div:nth-of-type(2) .c-stat-card-block {
			background-color: ds-color("bg", "accent");
		}

		div:nth-of-type(3) .c-stat-card-block {
			background-color: ds-color("bg", "dark");
			color: ds-color("fg", light);

			.c-stat-card-block__text-text {
				color: ds-color("fg", "on-color-muted");
			}

			.ds-brand-icon {
				--ds-brand-icon-line: var(--ds-color-fg-light);
			}
		}
	}
}
</style>
